import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { TimelineMax } from "gsap";


export default /*#__PURE__*/_defineComponent({
  __name: 'shutter-visual',
  props: {
    wideOnly: { type: Boolean, default: false },
    centered: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// template refs
const leftAspirationsShutterVisual = ref<HTMLElement | null>(null);
const rightAspirationsShutterVisual = ref<HTMLElement | null>(null);

const close = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=transitioned" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=transitioned" }, autoCss: true },
    0,
  );
};

const open = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=transitioned" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=transitioned" }, autoCss: true },
    0,
  );
};

const center = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=centered" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=centered" }, autoCss: true },
    0,
  );
};

const uncenter = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=centered" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=centered" }, autoCss: true },
    0,
  );
};

__expose({
  close,
  open,
  center,
  uncenter,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["background-visuals shutter-visual", { 'wide-only': _ctx.wideOnly, 'centered': _ctx.centered }])
  }, [
    _createElementVNode("div", {
      ref_key: "leftAspirationsShutterVisual",
      ref: leftAspirationsShutterVisual,
      class: "visual left-aspirations-shutter-visual show"
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "rightAspirationsShutterVisual",
      ref: rightAspirationsShutterVisual,
      class: "visual right-aspirations-shutter-visual show"
    }, null, 512)
  ], 2))
}
}

})